import * as _ from "lodash"

import {
  ISearch,
  ISearchProfile,
  ISearchProvider,
  HorizAlignment,
  SearchProviderFieldType,
  ISearchProviderField, ISearchRequestSubset, ITree, IProfileFilter, ISearchSort
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {ColumnNodeProvider} from "../PA.UIM.Core/SearchTreeUtils";

import {WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {ASync} from "../PA.Core/Basic/ASync";


const vWB_PrdGrp_Fields: {[id:string]: ISearchProviderField } = {
  WB_PRDGRP_ID:          {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
  PRODUCT_GROUP_ID:      {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Id', columnResourceName: 'colPGId', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PRODUCT_GROUP_NAME:    {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
  LEVEL_ID:              {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Level', columnResourceName: 'colLevel', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  STATUS_CODE:           {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Status', columnResourceName: 'colStatus', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  SOURCE_ID:             {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Source Id', columnResourceName: 'colSourceID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PRODUCT_GROUP_SET_ID:  {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Set Id', columnResourceName: 'colProductGroupSetID', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 50}},
  PLANNED_IND:           {type: SearchProviderFieldType.boolean, renderOptions: { columnName: 'Planned', columnResourceName: 'colPlanned', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 1}},
  TPM_PRDGRP_ROW_ID:     {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'TPM Row Id', columnResourceName: 'colTPMPrdGroupRowId', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}},
  CASE_PACK_SIZE:        {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'Case Pack Size', columnResourceName: 'colCasePackSize', alignment: HorizAlignment.Right, numberFormat: "#0.0"}, domainOptions: {}},
  STAT_CS_FACTOR:        {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'Stat Cs Factor', columnResourceName: 'colStatCsFactor', alignment: HorizAlignment.Right, numberFormat: "#0.0"}, domainOptions: {}},
  WEIGHT_FACTOR:         {type: SearchProviderFieldType.number, renderOptions:  { columnName: 'Weight Factor', columnResourceName: 'colWeightFactor', alignment: HorizAlignment.Right, numberFormat: "#0.0"}, domainOptions: {}},
  TREE_PATH:             {type: SearchProviderFieldType.string, renderOptions:  { columnName: 'Tree Path',      columnResourceName: 'colTreePath',     alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}}
}

const vWB_PrdGrp_KeyFields =
    {id:    'WB_PRDGRP_ID',
     id_ui: 'PRODUCT_GROUP_ID',
     name:  'PRODUCT_GROUP_NAME'}


class ProductGroupSearchByListSearchProvider
  implements  ISearchProvider {

  arrWB_PrdGrpRows:WB_ProductGroupRow[] = []

  constructor(WB_PrdGrpRows: WB_ProductGroupRow[]){
    this.arrWB_PrdGrpRows = WB_PrdGrpRows
  }

  get keyFields() { return vWB_PrdGrp_KeyFields }

  get searchProviderFields(){
    return vWB_PrdGrp_Fields
  }

  search(requestSpec: ISearchRequestSubset): Promise<any[]> {
    return ASync.resolve(_.map(this.arrWB_PrdGrpRows, (aWB_ProdRow: WB_ProductGroupRow) => {
      return aWB_ProdRow.toJSON()
    }))
  }

}


class ProductGroupSearchByListSearchProfile
  implements  ISearchProfile {

  aSearchProvider: ISearchProvider = undefined

  profileId = "default"
  profileName = "AutoSearch Only"
  renderOptions = { ui5ResourceId: "ProductGroupSearchByListProfile" }

  profileFilter: IProfileFilter[] = []

  profileDisplayFields = [
    'PRODUCT_GROUP_NAME','PRODUCT_GROUP_ID','LEVEL_ID','STATUS_CODE','CASE_PACK_SIZE','STAT_CS_FACTOR','WEIGHT_FACTOR'
  ]

  profileTreeIdDefault = "default"
  profileTrees: ITree[] = [
    {treeId: "default",
      treeName: "By Hierarchy",
      nodeProviders: [ new ColumnNodeProvider(['TREE_PATH'], {defaultValues: "No Product Group Tree Path Set", levelDelimiter: "\\", ruggedTree: true})],
      renderOptions: {}}
  ]

  // Do sorting last.. not necessary for phase 1
  profileSortIdDefault = ""    //string;
  profileSorts: ISearchSort[] = [] //ISearchSort[];


  constructor(WB_PrdGrpRows: WB_ProductGroupRow[]){
    this.aSearchProvider = new ProductGroupSearchByListSearchProvider(WB_PrdGrpRows)
  }

  get profileSearchProvider(){ return this.aSearchProvider }

}


export class ProductGroupSearchByList
  implements  ISearch {

  constructor(WB_PrdGrpRows: WB_ProductGroupRow[], options?: any){
    this.searchProfiles = [ new ProductGroupSearchByListSearchProfile(WB_PrdGrpRows) ]
  }

  searchName = "Select Product Group(s)"
  renderOptions = { ui5ResourceId: "ProductGroupSearchByList"}
  searchProfileIdDefault = "default"
  searchProfiles: ISearchProfile[] = []
  autoSearch = true


}
